import React, { PropsWithChildren, useContext, useMemo } from "react";
import { ThemeContext } from "styled-components";
import useMedia from "utils/hooks/useMedia.ts";
import {
  BOTTOM_NAVIGATOR,
  NEW_LOOK_BOTTOM_NAVIGATOR,
} from "common/constants.ts";
import { sharedLib } from "@shared/services/shared.service.ts";
import { selectWorkspace } from "@shared/slices/common.slice.ts";
import { WorkspaceType } from "@shared/types";
import { useSelector } from "react-redux";

const BottomNavigatorProvider = ({ children }: PropsWithChildren) => {
  const hasNewLookBreakpoints =
    !!useContext(ThemeContext)?.hasNewLookBreakpoints;
  const isBelowClassicBreakpoint = useMedia(
    [`(min-width: ${BOTTOM_NAVIGATOR})`],
    [false],
    true
  );
  const isBelowNewLookBreakpoint = useMedia(
    [`(min-width: ${NEW_LOOK_BOTTOM_NAVIGATOR})`],
    [false],
    true
  );
  const baseShouldDisplay = hasNewLookBreakpoints
    ? isBelowNewLookBreakpoint
    : isBelowClassicBreakpoint;

  const user = useSelector(sharedLib.selectors.authentication.selectRealUser);
  const workspace = useSelector(selectWorkspace);
  const shouldDisplay =
    baseShouldDisplay &&
    (!user?.is_onboarding || workspace === WorkspaceType.ADMIN);

  const contextValue = useMemo(() => {
    return { shouldDisplay, baseShouldDisplay };
  }, [shouldDisplay, baseShouldDisplay]);

  return (
    <BottomNavigatorContext.Provider value={contextValue}>
      {children}
    </BottomNavigatorContext.Provider>
  );
};

export default BottomNavigatorProvider;

export const BottomNavigatorContext = React.createContext<
  | {
      shouldDisplay: boolean;
      baseShouldDisplay: boolean;
    }
  | undefined
>(undefined);
